module.exports = __WEBPACK_EXTERNAL_MODULE_echarts_core__;